var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hiddBox",style:({textAlign:_vm.data.align,fontSize:_vm.data.fontSize+'px',fontWeight:_vm.data.weight,backgroundColor:_vm.data.bgColor,color:_vm.data.textColor})},[_vm._v(" "+_vm._s(_vm.data.bgColor)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }